module.exports = __webpack_public_path__ + "img/roll-1111.7bcc156a.png";